import axios from "axios";

/**
 * API client for MEMBER-facing calls (community area).
 * Uses cookies (HttpOnly member_session set by /api/community/auth) for auth.
 */
const memberApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true, // send session cookie
});

export default memberApi;
